import { createAsyncThunk } from '@reduxjs/toolkit'
// eslint-disable-next-line import/no-cycle
import {
  clearNotifs,
  getMarkers,
  getNotificationMessage,
  getEditProfileMessage,
  logOut,
  setAdminNotifRequest,
  setIsProfileChanged,
  setLogInCredentials,
  setMarkerUpdate,
  setPostPostsApiMsg,
  setPingStatus,
  setResTime1,
  setResTime2,
  setResTime3,
  setResTime4,
  setUserSectionPage,
  setVerificationEmailStandBy,
  signUp,
  removeMarker
} from 'store'
import { liveMarkerUpdate, staticMarkerUpdate } from 'store/markers/axios'
// eslint-disable-next-line import/no-cycle
import { usersApi } from 'store/users/api'
import {
  MY_PROFILES,
  REJECTED,
  SIGN_IN,
  SUCCEEDED,
  VERIFICATION_TYPES
} from 'utils/constants'
import {
  removeStorage,
  checkForceLogout,
  isAuth
} from 'utils/helpers'
import { LogoutFromChat } from 'store/chat/services'

const removeMarkerAndPopup = (dispatch, id, error) => {
  if (error.data.message === 'Profile doesn\'t exist') {
    const markerPopupOverlay = document.querySelector('#custom-popup-overlay')
    if (markerPopupOverlay) {
      markerPopupOverlay.click()
    }

    setTimeout(() => {
      dispatch(removeMarker(id))

      const northeast = JSON.parse(localStorage.getItem('northeast'))
      const southwest = JSON.parse(localStorage.getItem('southwest'))
      dispatch(staticMarkerUpdate({
        isAuth: isAuth(),
        northeast,
        southwest
      }))

      dispatch(liveMarkerUpdate({
        isAuth: isAuth(),
        northeast,
        southwest
      }))
    }, markerPopupOverlay ? 800 : 0)
  }
}

export const forceLogout = createAsyncThunk(
  'forceLogout',
  async (errMsg, { rejectWithValue, dispatch }) => {
    try {
      if (checkForceLogout(errMsg)) {
        dispatch(logOut(false))

        dispatch(
          getNotificationMessage({
            type: REJECTED,
            message: errMsg,
            isEditProfile: true
          })
        )

        return true
      }

      return false
    } catch (err) {
      return rejectWithValue(err.message)
    }
  }
)

const errLogic = async ({
  dispatch,
  error,
  rejectWithValue,
  isEditProfile
}) => {
  const doForceLogout = await dispatch(forceLogout(error.data.message))
  if (doForceLogout.payload === true) {
    return rejectWithValue(error.message)
  }

  dispatch(
    getNotificationMessage({
      type: REJECTED,
      message: error.data.message,
      isEditProfile
    })
  )

  return rejectWithValue(error.message)
}

export const getUserProfile = createAsyncThunk(
  'users/profile',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      let status = ''
      let stringCoordCount = 0
      const request_start = Date.now()
      const response = await usersApi.getUserProfiles()
      if (response.status === 200) {
        status = 'OK'
      } else {
        status = 'FAIL'
      }
      response.data.data.forEach((item) => {
        if (item.coordinates !== null) {
          if (typeof item.coordinates[0] === 'string' || typeof item.coordinates[1] === 'string') {
            // item.coordinates[0] = Number(parseFloat(item.coordinates[0]))
            // item.coordinates[1] = Number(parseFloat(item.coordinates[1]))
            stringCoordCount += 1
          }
        }
      })

      if (stringCoordCount > 0) {
        dispatch(getNotificationMessage({
          type: REJECTED,
          message: 'One of your profile coordinates value has wrong format.',
          isEditProfile: false
        }))
      }
      const request_end = Date.now()

      const duration = request_end - request_start
      await dispatch(setResTime3({ duration, status }))

      return response.data.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Get Users Profile Error',
          isEditProfile: true
        })
      )
      dispatch(setResTime3({ duration: null, status: 'FAIL' }))
      return rejectWithValue(error.message)
    }
  }
)

export const getUser = createAsyncThunk('users', async (_, { rejectWithValue, dispatch, getState }) => {
  try {
    const response = await usersApi.getUser()

    dispatch(getUserProfile())

    localStorage.setItem('userLatLS', response.data.data.lat)
    localStorage.setItem('userLngLS', response.data.data.lng)

    dispatch(setLogInCredentials({
      email: '',
      password: ''
    }))
    removeStorage('email')

    return response.data
  } catch (error) {
    const doForceLogout = await dispatch(forceLogout(error.data.message))
    if (doForceLogout.payload === true) {
      return rejectWithValue(error.message)
    }

    removeStorage('credentials')
    if (error.status === 403) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Email Address is not verified',
          isEditProfile: true
        })
      )

      if (error.data.message.includes('email address is not verified')) {
        const { auth } = getState()

        dispatch(setVerificationEmailStandBy({
          email: localStorage.getItem('email'),
          for: VERIFICATION_TYPES.Email
        }))
        dispatch(signUp({
          email: auth.tempEmail,
          password: auth.tempPassword
        }))
      }

      dispatch(setLogInCredentials({
        email: '',
        password: ''
      }))
      removeStorage('email')
    }

    return rejectWithValue(error.message)
  }
})

export const deleteUser = createAsyncThunk(
  'delete/user',
  async (activeProfile, { rejectWithValue, dispatch }) => {
    const notifyUiAfterProfileRemovalNotification = () => new Promise((resolve) => {
      window.addEventListener('custom-chat-profile-removed-notified', resolve, { once: true })
    })
    try {
      if (activeProfile !== undefined) {
        // Logout from XMPP before deleting the account to avoid XMPP wrong credentials error
        const event = new CustomEvent('custom-chat-profile-removed')
        window.dispatchEvent(event)
        await notifyUiAfterProfileRemovalNotification()
        await dispatch(LogoutFromChat())
      }

      const response = await usersApi.deleteUser()
      dispatch(
        getNotificationMessage({
          type: SUCCEEDED,
          message: 'Account Deleted',
          isEditProfile: true
        })
      )
      dispatch(logOut(false))
      setTimeout(() => dispatch(setUserSectionPage(SIGN_IN)), 850)
      return response.data.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Delete user error',
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const getAffinities = createAsyncThunk(
  'search/affinity',
  async (body, { rejectWithValue }) => {
    try {
      const response = await usersApi.searchAffinities(body)
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const updateSwitcher = createAsyncThunk(
  'update/Switcher',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.updateSwitcher(id)
      await dispatch(setMarkerUpdate(true))

      return response.data.data
    } catch (error) {
      await dispatch(forceLogout(error.data.message))

      return rejectWithValue(error.message)
    }
  }
)

export const getAdminNotifications = createAsyncThunk(
  'get/AdminNotifications',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const request_start = performance.now()
      const response = await usersApi.getAdminNotifications()
      const request_end = performance.now()
      // eslint-disable-next-line no-unused-vars
      const request_duration = request_end - request_start
      await dispatch(setAdminNotifRequest(request_end))
      return response.data
    } catch (error) {
      await dispatch(forceLogout(error.data.message))

      return rejectWithValue(error.message)
    }
  }
)

export const getCryptoBalance = createAsyncThunk(
  'get/crypto/balance',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getCryptoBalance({ profileId: id })

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const getFriendsNotifications = createAsyncThunk(
  'get/notifications',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getFriendsNotifications()
      return response.data.data
    } catch (error) {
      await dispatch(forceLogout(error.data.message))

      return rejectWithValue(error.message)
    }
  }
)

export const selectProfile = createAsyncThunk(
  'select/profile',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.selectProfile(body.profileId)
      await dispatch(getUserProfile())

      if (body.showNotifMsg) {
        await dispatch(getNotificationMessage({
          type: SUCCEEDED,
          message: 'User selected',
          isEditProfile: true
        }))
      }

      return response.data.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Failed to select user',
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const updateUserProfile = createAsyncThunk(
  'profile/update',
  async (body, { rejectWithValue, dispatch }) => {
    const {
      userData, id, formData, formData2, switcherData
    } = body

    userData.coordinates = [
      Number(parseFloat(userData.coordinates[0]).toFixed(6)),
      Number(parseFloat(userData.coordinates[1]).toFixed(6))
    ]

    try {
      let result = {}

      if (formData && formData2) {
        result = await Promise.all([
          usersApi.updateProfile(userData),
          usersApi.updateProfileImage(formData, id),
          usersApi.updateBanner(formData2, id)
        ])
      } else if (!formData && formData2) {
        result = await Promise.all([
          usersApi.updateProfile(userData),
          usersApi.updateBanner(formData2, id)
        ])
      } else if (formData && !formData2) {
        result = await Promise.all([
          usersApi.updateProfile(userData),
          usersApi.updateProfileImage(formData, id)
        ])
      } else {
        result = await Promise.all([usersApi.updateProfile(userData)])
      }

      await dispatch(setIsProfileChanged(false))
      await dispatch(selectProfile({
        profileId: id,
        showNotifMsg: false
      }))
      await dispatch(getUserProfile())
      await dispatch(updateSwitcher(switcherData))

      if (userData?.wallet_address) {
        dispatch(getCryptoBalance(id))
      }

      dispatch(
        getNotificationMessage({
          type: SUCCEEDED,
          message: 'Saved',
          isEditProfile: true
        })
      )

      const event = new CustomEvent('custom-chat-avatar_change', {
        detail: {
          full_name: userData.full_name
        }
      })
      window.dispatchEvent(event)

      return result.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      if (error.status === 422) {
        let errorMessage = ''
        let SocialLink = []
        let CodeWord = []
        let data = []
        let data2 = []
        let data3 = []
        if (error.data.errors.profile_picture) {
          data = error.data.errors.profile_picture
          data.forEach((item) => { errorMessage += ' ' + item + '\n' })
          dispatch(
            getNotificationMessage({
              type: REJECTED,
              message: errorMessage,
              isEditProfile: true
            })
          )
        }
        if (error.data.errors.code_words || error.data.errors.socialLinks) {
          data2 = error.data.errors.code_words
          data3 = error.data.errors.socialLinks
          if (data2 && !data3) {
            data2.forEach((item) => {
              if (item) {
                CodeWord.push(item?.match(/"(.*?)"/)?.[1])
              }
            })
          } else if (!data2 && data3) {
            data3.forEach((item) => {
              if (item) {
                SocialLink.push(item.replace('Invalid URL in ', ''))
              }
            })
          } else {
            data2.forEach((item) => {
              if (item) {
                CodeWord.push(item?.match(/"(.*?)"/)?.[1])
              }
            })
            data3.forEach((item) => {
              if (item) {
                SocialLink.push(item.replace('Invalid URL in ', ''))
              }
            })
          }
          dispatch(
            getEditProfileMessage({
              message1: CodeWord,
              message2: SocialLink
            })
          )
        } else {
          dispatch(
            getNotificationMessage({
              type: REJECTED,
              message: error.data.message,
              isEditProfile: true
            })
          )
        }
      } else {
        // If an xmpp error, there should be a long, confusing message
        dispatch(
          getNotificationMessage({
            type: REJECTED,
            message: 'Oops, something went wrong with the server. Please try again later',
            isEditProfile: true
          })
        )
      }

      return rejectWithValue(error.message)
    }
  }
)

export const deleteUserProfile = createAsyncThunk(
  'delete/profile',
  async (id, { rejectWithValue, dispatch, getState }) => {
    const notifyUiAfterProfileRemovalNotification = () => new Promise((resolve) => {
      window.addEventListener('custom-chat-profile-removed-notified', resolve, { once: true })
    })
    try {
      const { users } = getState()
      if (users.activeProfile.id === id) {
        // Logout from XMPP before deleting a profile to avoid XMPP wrong credentials error
        // More details can be seen on task #664
        const event = new CustomEvent('custom-chat-profile-removed')
        window.dispatchEvent(event)
        await notifyUiAfterProfileRemovalNotification()
        await dispatch(LogoutFromChat())
        await dispatch(clearNotifs())
        await dispatch(getUserProfile())
        await dispatch(getMarkers({ isAuth: true }))
      }

      // this is not active profile deleted, not needed to exit from chat and switch profile
      const response = await usersApi.deleteProfile(id)
      dispatch(
        getNotificationMessage({
          type: SUCCEEDED,
          message: 'Profile has been deleted',
          isEditProfile: true
        })
      )

      dispatch(setUserSectionPage(null))
      dispatch(setUserSectionPage(null))
      dispatch(setUserSectionPage(MY_PROFILES))

      dispatch(getUserProfile())
      return response.data.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Failed to delete profile',
          isEditProfile: true
        })
      )
      return rejectWithValue(error.message)
    }
  }
)

export const getSearchParams = createAsyncThunk(
  'search/params',
  async (body, { rejectWithValue }) => {
    try {
      const response = await usersApi.getSearchParams(body)

      return response.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const updateUserSettings = createAsyncThunk(
  'user/setting',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.updateSettings(data.body)

      if (data.type === 'email') {
        dispatch(
          getNotificationMessage({
            type: SUCCEEDED,
            message: 'Verification code sent to your email',
            isEditProfile: true
          })
        )
      } else {
        dispatch(
          getNotificationMessage({
            type: SUCCEEDED,
            message: 'Saved',
            isEditProfile: true
          })
        )
      }

      dispatch(getUser())
      return response.data.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      if (error.status === 422) {
        const errorType = Object.values(error.data)[1]

        if (Object.keys(errorType)[0] === 'email') {
          dispatch(
            getNotificationMessage({
              type: REJECTED,
              message: 'The email has already been taken.',
              isEditProfile: true
            })
          )
        }
        if (Object.keys(errorType)[0] === 'password_current') {
          dispatch(
            getNotificationMessage({
              type: REJECTED,
              message: 'Current password is incorrect',
              isEditProfile: true
            })
          )
        }
      } else {
        dispatch(
          getNotificationMessage({
            type: REJECTED,
            message: 'Oops, something went wrong with the server. Please try again later',
            isEditProfile: true
          })
        )
      }

      return rejectWithValue(error.message)
    }
  }
)

export const addFriend = createAsyncThunk('add/friend', async (id, { rejectWithValue, dispatch }) => {
  try {
    const response = await usersApi.addFriend(id)

    dispatch(
      getNotificationMessage({
        type: SUCCEEDED,
        message: response.data.message
      })
    )

    return response.data
  } catch (error) {
    const doForceLogout = await dispatch(forceLogout(error.data.message))
    if (doForceLogout.payload === true) {
      return rejectWithValue(error.message)
    }

    removeMarkerAndPopup(dispatch, id, error)

    if (error.status === 422) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message
        })
      )
    }

    return rejectWithValue({
      message: error.message,
      data: error.data
    })
  }
})

export const deleteFriend = createAsyncThunk(
  'delete/friend',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.deleteFriend(id)

      dispatch(
        getNotificationMessage({
          type: SUCCEEDED,
          message: response.data.message
        })
      )

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      removeMarkerAndPopup(dispatch, id, error)

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message
        })
      )

      return rejectWithValue({
        message: error.message,
        data: error.data
      })
    }
  }
)

export const removeFriendRequest = createAsyncThunk(
  'delete/friend-request',
  async (recipientId, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.removeFriendRequest({ recipientId })

      dispatch(
        getNotificationMessage({
          type: SUCCEEDED,
          message: response.data.message
        })
      )

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      removeMarkerAndPopup(dispatch, recipientId, error)

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message
        })
      )

      return rejectWithValue({
        message: error.message,
        data: error.data
      })
    }
  }
)

export const getBlockedRequest = createAsyncThunk(
  'get/blockedRequest',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getBlockedRequest(id)
      // dispatch(getFriendsNotifications())

      return response.data.data
    } catch (error) {
      await dispatch(forceLogout(error.data.message))
      return rejectWithValue(error.message)
    }
  }
)

export const acceptFriend = createAsyncThunk(
  'add/acceptFriend',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.acceptFriend(body?.id)
      dispatch(getBlockedRequest(body?.activeId))
      dispatch(getFriendsNotifications())

      dispatch(
        getNotificationMessage({
          type: SUCCEEDED,
          message: 'Friend request accepted'
        })
      )

      return response.data.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message
        })
      )

      return rejectWithValue({
        message: error.message,
        data: error.data
      })
    }
  }
)

export const blogNotifsCount = createAsyncThunk(
  'get/blog-notifs-count',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.blogNotifsCount()

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const denyFriend = createAsyncThunk(
  'delete/denyFriend',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.denyFriend(body?.id)
      dispatch(blogNotifsCount())
      dispatch(getFriendsNotifications())
      dispatch(getBlockedRequest(body?.activeId))
      return response.data.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(getFriendsNotifications())
      dispatch(getBlockedRequest(body.activeId))

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message
        })
      )

      return rejectWithValue({
        message: error.message,
        data: error.data
      })
    }
  }
)

export const getProfileItem = createAsyncThunk(
  'delete/getProfileItem',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getProfileItem(id)

      return response.data.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      removeMarkerAndPopup(dispatch, id, error)

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const postMakeNotificationSeen = createAsyncThunk(
  'post/MakeNotificationSeen',
  // eslint-disable-next-line consistent-return
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.postMakeNotificationSeen(body)
      localStorage.setItem('openedNotifId', body.notificationId)

      return response.data.data
    } catch (error) {
      await dispatch(forceLogout(error.data.message))

      return rejectWithValue(error.message)
    }
  }
)

export const postMakeNotificationSeenAll = createAsyncThunk(
  'post/MakeNotificationSeenAll',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.postMakeNotificationSeenAll(body)

      return response.data.data
    } catch (error) {
      await dispatch(forceLogout(error.data.message))

      return rejectWithValue(error.message)
    }
  }
)

export const connectionRequestSeenAll = createAsyncThunk(
  'post/connectionRequestSeenAll',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.connectionRequestSeenAll()

      return response.data.data
    } catch (error) {
      await dispatch(forceLogout(error.data.message))

      return rejectWithValue(error.message)
    }
  }
)

export const getSocialLinksCategories = createAsyncThunk(
  'get/socialLinksCategories',
  async (_, { rejectWithValue }) => {
    try {
      const response = await usersApi.getSocialLinksCategories()
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const getSocialLinks = createAsyncThunk(
  'search/socialLinks',
  async (body, { rejectWithValue }) => {
    try {
      const response = await usersApi.searchSocialLinks(body)
      return response.data.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const getFrequency = createAsyncThunk(
  'get/frequency',
  async (_, { rejectWithValue }) => {
    try {
      const response = await usersApi.getFrequency()
      return response.data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const setLiveLocData = createAsyncThunk(
  'get/LiveLocData',
  async (data, { rejectWithValue, dispatch }) => {
    const { id, coordinates } = data
    try {
      const response = await usersApi.setLiveLocData(id, coordinates)
      return response.data
    } catch (error) {
      await dispatch(forceLogout(error.data.message))

      return rejectWithValue(error.message)
    }
  }
)

export const getPingTest = createAsyncThunk(
  'get/pingTest',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getPingTest()
      const request_start = Date.now()
      if (response.status === 204) {
        dispatch(setPingStatus('OK'))
      } else {
        dispatch(setPingStatus('FAIL'))
      }
      const request_end = Date.now()
      const duration = request_end - request_start
      let serverName = process.env.REACT_APP_API_URL
      if (serverName.includes('127.0.0.1')) {
        serverName = 'localhost'
      } else {
        // eslint-disable-next-line prefer-destructuring
        serverName = serverName.split('://')[1]
        // eslint-disable-next-line prefer-destructuring
        serverName = serverName.split('/api')[0]
      }
      await dispatch(setResTime1({ duration, serverName }))
      return response.data
    } catch (error) {
      let serverName = process.env.REACT_APP_API_URL
      if (serverName.includes('127.0.0.1')) {
        serverName = 'localhost'
      } else {
        // eslint-disable-next-line prefer-destructuring
        serverName = serverName.split('://')[1]
        // eslint-disable-next-line prefer-destructuring
        serverName = serverName.split('/api')[0]
      }

      dispatch(setPingStatus('FAIL'))
      dispatch(setResTime1({ duration: null, serverName }))
      return rejectWithValue(error.message)
    }
  }
)

export const getFileTest = createAsyncThunk(
  'get/itemTest',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      let status = ''
      const request_start = Date.now()
      const response = await usersApi.getFileTest()
      if (response.status === 200) {
        status = 'OK'
      } else {
        status = 'FAIL'
      }
      const request_end = Date.now()
      const duration = request_end - request_start
      await dispatch(setResTime2({ duration, status }))
      return response.data
    } catch (error) {
      dispatch(setResTime2({ duration: null, status: 'FAIL' }))
      return rejectWithValue(error.message)
    }
  }
)

export const setDataTest = createAsyncThunk(
  'set/dataTest',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      let status = ''
      const request_start = Date.now()
      const response = await usersApi.setDataTest(data)
      if (response.status === 200) {
        status = 'OK'
      } else {
        status = 'FAIL'
      }
      const request_end = Date.now()
      const duration = request_end - request_start
      await dispatch(setResTime4({ duration, status }))
      return response.data
    } catch (error) {
      dispatch(setResTime4({ duration: null, status: 'FAIL' }))
      return rejectWithValue(error.message)
    }
  }
)

export const archiveRequest = createAsyncThunk(
  'set/archiveRequest',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.archiveRequest(body.id)
      dispatch(getFriendsNotifications())
      dispatch(getBlockedRequest(body.activeId))

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(getFriendsNotifications())
      dispatch(getBlockedRequest(body.activeId))

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message
        })
      )

      return rejectWithValue({
        message: error.message,
        data: error.data
      })
    }
  }
)

export const addImagePosts = createAsyncThunk(
  'posts/add-image',
  async (image, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.addImagePosts(image)

      return response.data
    } catch (error) {
      return errLogic({
        dispatch,
        error,
        rejectWithValue,
        isEditProfile: true
      })
    }
  }
)

export const addImagePostsSilent = createAsyncThunk(
  'posts/add-image/silent',
  async (image, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.addImagePosts(image)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      return rejectWithValue(error.message)
    }
  }
)

export const getImagePosts = createAsyncThunk(
  'posts/get-image',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getImagePosts(body)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Image not found',
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const updateLastSeenOfPost = createAsyncThunk(
  'post/UpdateLastSeenOfPost',
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const { users } = getState()

      if (
        users.postLastSeenData?.lastItemId
        || (
          users.postLastSeenData?.type !== 'affinity'
          && users.postLastSeenData?.type !== 'all'
          && users.postLastSeenData?.type !== 'friends'
          && users.postLastSeenData?.type !== 'marker'
          && users.postLastSeenData?.type !== 'subscribed'
        )
      ) {
        return null
      }

      const response = await usersApi.updateLastSeenOfPost(users.postLastSeenData)

      return response.data.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      return rejectWithValue(error.message)
    }
  }
)

export const getPosts = createAsyncThunk(
  'get/posts',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getPosts(body)

      response.data.posts.forEach((e) => {
        const parsedBody = JSON.parse(e.body)
        e.body = parsedBody

        if (e?.repost_post_id) {
          if (e?.repostPostData?.id && e?.repostPostData?.profile_id) {
            const parsedRepostPostBody = JSON.parse(e.repostPostData.body)
            e.repostPostData.body = parsedRepostPostBody

            let imageCountOnRepost = 0
            Object.values(parsedRepostPostBody.entityMap).forEach(async (e2) => {
              if (e2.type === 'IMAGE') {
                dispatch(getImagePosts({
                  postId: e.repostPostData.id,
                  parentPostId: e.id,
                  fileName: e2.data.src,
                  type: 'repostedArticle'
                }))
                imageCountOnRepost += 1
              }
            })

            e.repostPostData.imageCount = imageCountOnRepost
            e.repostPostData.imageLoaded = 0
          } else {
            e.repostPostData = {}
          }
        }

        let imageCount = 0
        Object.values(parsedBody.entityMap).forEach(async (e2) => {
          if (e2.type === 'IMAGE') {
            dispatch(getImagePosts({
              postId: e.id,
              fileName: e2.data.src
            }))
            imageCount += 1
          }
        })

        e.imageCount = imageCount
        e.imageLoaded = 0
      })

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      const noActiveProfileMsg = 'You do not have an active profile. Please setup your profile first'
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message.includes(noActiveProfileMsg) ? noActiveProfileMsg + ' to see the posts.' : error.data.message,
          isEditProfile: false
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

const postPostsLogic = async ({
  response,
  data,
  dispatch,
  silent = false
}) => {
  response.data.post.forEach((e) => {
    const parsedBody = JSON.parse(e.body)
    e.body = parsedBody

    if (e?.repost_post_id) {
      if (e?.repostPostData?.id && e?.repostPostData?.profile_id) {
        const parsedRepostPostBody = JSON.parse(e.repostPostData.body)
        e.repostPostData.body = parsedRepostPostBody

        let imageCountOnRepost = 0
        Object.values(parsedRepostPostBody.entityMap).forEach(async (e2) => {
          if (e2.type === 'IMAGE') {
            dispatch(getImagePosts({
              postId: e.repostPostData.id,
              parentPostId: e.id,
              fileName: e2.data.src,
              type: 'repostedArticle'
            }))
            imageCountOnRepost += 1
          }
        })

        e.repostPostData.imageCount = imageCountOnRepost
        e.repostPostData.imageLoaded = 0
      } else {
        e.repostPostData = {}
      }
    }

    if (
      (data.body.type === 'post' && data.postsTypeStatus === 'posted')
      || (data.body.type === 'archive' && data.postsTypeStatus === 'archived')
      || (data.body.type === 'plan' && data.postsTypeStatus === 'scheduled')
    ) {
      let imageCount = 0
      Object.values(parsedBody.entityMap).map(async (e2) => {
        if (e2.type === 'IMAGE') {
          dispatch(getImagePosts({
            postId: e.id,
            fileName: e2.data.src
          }))
          imageCount += 1
        }
      })

      e.imageCount = imageCount
      e.imageLoaded = 0
    }
  })

  if (!silent) {
    let msg = 'Successfully Posted'
    if (data.body.type === 'archive') {
      msg = 'Saved in Archive'
    } else if (data.body.type === 'plan') {
      msg = 'Saved in Schedule'
    }

    dispatch(setPostPostsApiMsg(msg))
    setTimeout(() => dispatch(setPostPostsApiMsg('')), 3000)
  }

  return response.data
}

export const postPosts = createAsyncThunk(
  'post/posts',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.postPosts(data.body)

      return postPostsLogic({
        response,
        data,
        dispatch
      })
    } catch (error) {
      return errLogic({
        dispatch,
        error,
        rejectWithValue,
        isEditProfile: true
      })
    }
  }
)

export const postPostsSilent = createAsyncThunk(
  'post/posts/silent',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.postPosts(data.body)

      return postPostsLogic({
        response,
        data,
        dispatch,
        silent: true
      })
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      return rejectWithValue(error.message)
    }
  }
)

const putPostsLogic = async ({
  response,
  data,
  dispatch,
  silent
}) => {
  response.data.post.forEach((e) => {
    const parsedBody = JSON.parse(e.body)
    e.body = parsedBody

    if (e?.repost_post_id) {
      if (e?.repostPostData?.id && e?.repostPostData?.profile_id) {
        const parsedRepostPostBody = JSON.parse(e.repostPostData.body)
        e.repostPostData.body = parsedRepostPostBody

        let imageCountOnRepost = 0
        Object.values(parsedRepostPostBody.entityMap).forEach(async (e2) => {
          if (e2.type === 'IMAGE') {
            dispatch(getImagePosts({
              postId: e.repostPostData.id,
              parentPostId: e.id,
              fileName: e2.data.src,
              type: 'repostedArticle'
            }))
            imageCountOnRepost += 1
          }
        })

        e.repostPostData.imageCount = imageCountOnRepost
        e.repostPostData.imageLoaded = 0
      } else {
        e.repostPostData = {}
      }
    }

    if (
      (data.body.type === 'post' && data.postsTypeStatus === 'posted')
      || (data.body.type === 'archive' && data.postsTypeStatus === 'archived')
      || (data.body.type === 'plan' && data.postsTypeStatus === 'scheduled')
    ) {
      let imageCount = 0
      Object.values(parsedBody.entityMap).map(async (e2) => {
        if (e2.type === 'IMAGE') {
          dispatch(getImagePosts({
            postId: e.id,
            fileName: e2.data.src
          }))
          imageCount += 1
        }
      })

      e.imageCount = imageCount
      e.imageLoaded = 0
    }
  })

  if (!silent) {
    let msg = 'Post Edited'
    if (data.body.type === 'archive') {
      msg = 'Saved in Archive'
    } else if (data.body.type === 'plan') {
      msg = 'Saved in Schedule'
    }

    dispatch(setPostPostsApiMsg(msg))
    setTimeout(() => dispatch(setPostPostsApiMsg('')), 3000)
  }

  return response.data
}

export const putPosts = createAsyncThunk(
  'put/posts',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.putPosts(data.body)

      return putPostsLogic({
        response,
        data,
        dispatch
      })
    } catch (error) {
      return errLogic({
        dispatch,
        error,
        rejectWithValue,
        isEditProfile: true
      })
    }
  }
)

export const putPostsSilent = createAsyncThunk(
  'put/posts/silent',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.putPosts(data.body)

      return putPostsLogic({
        response,
        data,
        dispatch,
        silent: true
      })
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      return rejectWithValue(error.message)
    }
  }
)

export const deletePosts = createAsyncThunk(
  'delete/posts',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.deletePosts(data)

      dispatch(setPostPostsApiMsg('Successfully deleted'))
      setTimeout(() => dispatch(setPostPostsApiMsg('')), 3000)

      return response.data
    } catch (error) {
      return errLogic({
        dispatch,
        error,
        rejectWithValue,
        isEditProfile: true
      })
    }
  }
)

export const deletePostsSilent = createAsyncThunk(
  'delete/posts/silent',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.deletePosts(data)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      return rejectWithValue(error.message)
    }
  }
)

export const likePost = createAsyncThunk(
  'post/like',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.likePost({ id })

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Article unavailable or deleted',
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const sharePost = createAsyncThunk(
  'post/share',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.sharePost({ id })

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      return rejectWithValue(error.message)
    }
  }
)

export const savePost = createAsyncThunk(
  'post/save',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.savePost({ id })

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      return rejectWithValue(error.message)
    }
  }
)

export const getBlogPreference = createAsyncThunk(
  'get/blog-preference',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getBlogPreference()

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const blogPreferenceAllContacts = createAsyncThunk(
  'get/blog-preference/all-contacts',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.blogPreferenceAllContacts()
      await dispatch(getBlogPreference())

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const blogPreferenceAllUsers = createAsyncThunk(
  'get/blog-preference/all-users',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.blogPreferenceAllUsers()
      await dispatch(getBlogPreference())

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const addBlogPreference = createAsyncThunk(
  'set/blog-preference',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.addBlogPreference({ id })
      await dispatch(getBlogPreference())

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const removeBlogPreference = createAsyncThunk(
  'delete/blog-preference',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.removeBlogPreference({ id })
      await dispatch(getBlogPreference())

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const getComments = createAsyncThunk(
  'get/comments',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getComments(body)

      return response.data
    } catch (error) {
      await dispatch(forceLogout(error.data.message))

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'Article unavailable or deleted',
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const postComments = createAsyncThunk(
  'post/comments',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.postComments(body)

      dispatch(
        getNotificationMessage({
          type: SUCCEEDED,
          message: 'Comment created',
          isEditProfile: true
        })
      )
      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const likeComment = createAsyncThunk(
  'post/commment',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.likeComment({ id })

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const putComments = createAsyncThunk(
  'put/comments',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.putComments({
        id: body.id,
        type: body.type,
        comment_id: body.comment_id,
        body: body.body
      })

      dispatch(
        getNotificationMessage({
          type: SUCCEEDED,
          message: 'Comment updated',
          isEditProfile: true
        })
      )
      return response.data
    } catch (error) {
      await dispatch(forceLogout(error.data.message))
      return rejectWithValue(error.message)
    }
  }
)

export const subscribeToProfile = createAsyncThunk(
  'post/subscribeToProfile',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.subscribeToProfile(body)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const pinFriend = createAsyncThunk(
  'post/pinFriend',
  async (friendId, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.pinFriend({ friendId })

      let pinnedFriends = JSON.parse(localStorage.getItem('pinnedFriends')) ?? []

      if (response.data.msg === 'Pinned') {
        pinnedFriends.splice(0, 0, response.data.data)
      } else if (
        response.data.msg === 'Unpinned'
        && pinnedFriends.length
      ) {
        pinnedFriends = pinnedFriends.filter((friend) => friend.friendId !== parseInt(friendId, 10))
      }

      localStorage.setItem('pinnedFriends', JSON.stringify(pinnedFriends))

      const event = new CustomEvent('rerender-chat-list')
      window.dispatchEvent(event)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: false
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const getPinnedFriends = createAsyncThunk(
  'get/getPinnedFriends',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getPinnedFriends()

      localStorage.setItem('pinnedFriends', JSON.stringify(response.data.data))

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: false
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const getEngagementItems = createAsyncThunk(
  'get/engagements/items',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getEngagementItems(body)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: false
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const lastSeenEngagement = createAsyncThunk(
  'patch/engagements/last_seen',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.lastSeenEngagement(body)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: false
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const eventSeenAll = createAsyncThunk(
  'patch/events/seen_all',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.eventSeenAll()

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: false
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const getSavedEvents = createAsyncThunk(
  'get/event/saved',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getSavedEvents(body)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: false
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const saveEvent = createAsyncThunk(
  'post/event/save',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.saveEvent(body)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: false
        })
      )

      return rejectWithValue(error.data)
    }
  }
)

export const getEventComments = createAsyncThunk(
  'get/event/comment',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.getEventComments(body)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const postEventComment = createAsyncThunk(
  'post/event/comment',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.postEventComment(body)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const putEventComment = createAsyncThunk(
  'put/event/comment',
  async (body, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.putEventComment(body)

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const likeEventComment = createAsyncThunk(
  'like/event/comment',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.likeEventComment({ id })

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: error.data.message,
          isEditProfile: true
        })
      )

      return rejectWithValue(error.message)
    }
  }
)

export const seenVideoLinkNotice = createAsyncThunk(
  'post/seen-video-link-notice',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await usersApi.seenVideoLinkNotice({ id })

      return response.data
    } catch (error) {
      const doForceLogout = await dispatch(forceLogout(error.data.message))
      if (doForceLogout.payload === true) {
        return rejectWithValue(error.message)
      }

      return rejectWithValue(error.message)
    }
  }
)
